// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8ba57c0","952":"5ba36ac3"}[chunkId] + ".chunk.js";
};